import { Typography } from "@circle-react-uikit/Typography";

export const Placeholder = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => (
  <div className="mt-[200px] flex size-full flex-col items-center gap-3">
    <Typography.TitleMd>{title}</Typography.TitleMd>
    <Typography.BodyMd>{description}</Typography.BodyMd>
  </div>
);
